// extracted by mini-css-extract-plugin
module.exports = {"root":"IconInfo_root__1EwMS"};